import { render, staticRenderFns } from "./levelsForm.vue?vue&type=template&id=07c1911c&scoped=true"
import script from "./levelsForm.vue?vue&type=script&lang=js"
export * from "./levelsForm.vue?vue&type=script&lang=js"
import style0 from "./levelsForm.vue?vue&type=style&index=0&id=07c1911c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c1911c",
  null
  
)

export default component.exports